<template>
  <div class="mb-2">
    <validation-observer ref="formModalObserver" novalidate tag="form">
      <div class="row">
        <div class="col-12 mb-3">
          <icon-view
            :has-border="false"
            icon="fas fa-arrow-to-left text-orange fa-lg pt-1"
            title="Notificar Devolución"
            variant="custom-icon-view"
            icon-background="white"
          />
        </div>
        <div class="col-12 col-md-3 mb-4">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-date-picker
              label="Fecha de Devolución de Libro:"
              v-model="model.returnDate"
              :max-date="maxDate"
              :min-date="minDate"
              placeholder="DD/MM/YYYY"
              class="custom-datetime-picker-container"
              container-class="w-100"
              :error="errors[0]"
              custom-error-msg="La fecha es requerida"
            />
          </validation-provider>
        </div>
        <div class="col-12 mb-4">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-text-area
              id="txtComment"
              :maxlength="3000"
              placeholder="Escribe un comentario"
              label="Comentario:"
              v-model="model.comment"
              :error="errors[0]"
              custom-error-msg="Este campo es requerido"
            />
          </validation-provider>
        </div>
      </div>
    </validation-observer>
    <div class="d-flex justify-content-end align-items-center mt-4">
      <action-button
        id="btnCancel"
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3 px-3"
        @click="$emit('close')"
      />
      <action-button
        id="btnSave"
        i="fas fa-save"
        text="Guardar"
        variant="success px-3"
        @click="handlerSave"
      />
    </div>
  </div>
</template>
<script>
import ActionButton from "ActionButton";
import IconView from "icon-view";
import CustomTextArea from "CustomTextArea";
import CustomCallout from "custom-callout";
import CustomResultNotFound from "custom-result-not-found";
import CustomDatePicker from "custom-date-picker";

import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin.js";
import inventoryCatalogService from "@/services/api/inventorycatalog.api";
import { name as appModuleName } from "@/modules/app/store/index";
import { mapGetters } from "vuex";
import moment from 'moment';

export default {
  name: "NotifyReturn",
  components: {
    ActionButton,
    IconView,
    CustomTextArea,
    CustomCallout,
    CustomResultNotFound,
    CustomDatePicker
  },
  mixins: [alertMixin],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      minDate: null,
      model: {
        comment: "",
        returnDate: null
      }
    };
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: "getIsMobileDensity"
    }),
    maxDate(){
      return new Date();
    }
  },
  mounted() {
    this.getMinDate();
  },
  methods: {
    async handlerSave() {
      const isvalid = await this.$refs.formModalObserver.validate();
      if (!isvalid) {
        this.ShowToast(
          "Alerta",
          "Por favor completa los campos requeridos.",
          "error"
        );
        return;
      }

      const confirmed = await this.ShowCancelModal(
        "Confirmación",
        `¿Está seguro que desea guardar la información documentada?`,
        "Sí",
        "No"
      );

      if (!confirmed) return;

      this.$emit("save", { ...this.model });
    },
    async getMinDate() {
      const { data } = await inventoryCatalogService.getInititalReturnDate(
        this.item.id
      );
      this.minDate = moment(data).subtract(1, 'days').format();
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .custom-datetime-picker-container.width-container {
  width: 100% !important;
}
</style>
